// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xV1-","comment":"styles_comment__3_yVh"};